import type { ReactNode } from "react";
import {
  CoworldHeaderView,
  type CoworldHeaderStat,
} from "@softmax/product-ux/coworld-header";
import { formatInt } from "@softmax/product-ux/play-values";
import { formatRelative } from "../../play/state";
import type { PreviewContent } from "../content/preview-content.types";
import { coworldHeaderArt } from "../data/coworld-art";
export function coworldStats({
  preview,
  now,
  prize,
}: {
  preview: PreviewContent;
  now: string;
  prize: string | null;
}): CoworldHeaderStat[] {
  const stats: CoworldHeaderStat[] = [];

  if (preview.playerCount !== null)
    stats.push({ label: "Players", value: formatInt(preview.playerCount) });

  if (preview.lastRoundAt !== null)
    stats.push({
      label: "Last round",
      value: formatRelative({ iso: preview.lastRoundAt, now, timeZone: "UTC" }),
    });

  const league =
    preview.leagueName === preview.name ? null : preview.leagueName;
  const cadence = preview.copy.cadenceShort;

  if (league !== null)
    stats.push({
      label: "Format",
      value: cadence === null ? league : `${league}, ${cadence}`,
    });
  else if (cadence !== null) stats.push({ label: "Rounds", value: cadence });

  if (prize !== null) stats.push({ label: "Prize", value: prize });

  return stats;
}
export function CoworldHeader({
  slug,
  coverSrc,
  icon,
  name,
  site,
  about,
  stats,
  anchored,
  after,
}: {
  after?: ReactNode;
  anchored?: boolean | undefined;
  slug: string;
  coverSrc: string | undefined;
  icon?: string | null;
  name: string;
  site: string | undefined;
  about: ReactNode;
  stats: CoworldHeaderStat[];
}) {
  return (
    <CoworldHeaderView
      art={coworldHeaderArt({
        slug,
        coverSrc,
        name,
        storePageIcon: icon,
      })}
      name={name}
      site={site}
      about={about}
      stats={stats}
      anchored={anchored}
      after={after}
    />
  );
}
